/**
 * Converts angle in degrees to radians
 */
export function prizmToRadians(deg: number): number {
  return (deg * Math.PI) / 180;
}
